/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./Alert.vue?vue&type=template&id=bcc9d88e&scoped=true"
import script from "./Alert.ts?vue&type=script&lang=ts&external"
export * from "./Alert.ts?vue&type=script&lang=ts&external"
import style0 from "./Alert.vue?vue&type=style&index=0&id=bcc9d88e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc9d88e",
  null
  
)

export default component.exports